export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const EXPAND_MENU = 'EXPAND_MENU'

export const SWITCH_EFFECT = 'SWITCH_EFFECT'

export const AUTHENTICATED = 'authenticated'

export const TIMESHEET_PAGE = 'timesheetPage'

export const EVENT_COUNT = 'EVENT_COUNT'

export const TIMESHEET_STATUS = 'timesheetStatus'

export const DATETIME_TIMESHEET = 'datetimemytimesheet'

export const DATETIME_OTSTATUS = 'datetimeotstatus'

export const DATETIME_TOTALOT = 'datetimetotalot'

export const DATETIME_TIMESHEETLIST = 'datetimetimesheetlist'

export const ALLOWANCE_SWITCH = 'allowanceSwitch'



// WEBPACK FOOTER //
// ./client/store/mutation-types.js